import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

// create
let mm = gsap.matchMedia();

// add a media query. When it matches, the associated function will run
mm.add("(min-width: 1024px)", () => {
	/* Statistic sticky slider */

	/* turn items into arrays */
	var resourceStats = gsap.utils.toArray(".statistics__stat");
	var resourceTitles = gsap.utils.toArray(".statistics__title");
	var resourceImgs = gsap.utils.toArray(".statistics__image");

	/* count stats ignoring the last one to continue scroll on last stat */
	var resourceNumStats = resourceStats.length - 1;

	/* 
				potential option: scroll spacing static value 
				i.e. 200 rather  than $(".statistics__stat").outerHeight()
			*/

	/* 
				function for calculating height of stat div and assuming
				these match in height, the total height of all stats 
			*/
	function resourceStatsHeight() {
		return {
			item: $(".statistics__stat").outerHeight(),
			total: $(".statistics__stat").outerHeight() * resourceNumStats,
		};
	}

	/* work out start and end time */
	function resourceStatPositions(i) {
		var statStart, statEnd;

		/* always triggers from top of screen i.e. +=number top */

		if (i == 0) {
			// if first in loop
			statStart = "top bottom"; // add active stat before top of section hits bottom of screen
			statEnd = "+=" + resourceStatsHeight()["item"] + " top"; // no longer active after height of item
		} else if (i == resourceNumStats) {
			// if last in loop
			statStart = resourceStatsHeight()["total"] - 1 + " top"; // total height of other items added together (minus 1 to create overlap so always has one stat that is active)
			statEnd = "bottom+=" + resourceStatsHeight()["total"] + " top"; // remove active stat after bottom of section hits top of screen, due to pinning this is added to distance from bottom of section
		} else if (i > 0 && i < resourceNumStats) {
			// if between first and last in loop
			statStart = "+=" + (resourceStatsHeight()["item"] - 1) * i + " top"; // add active when height of item * number of stat i.e. (height - 1) * 2
			statEnd = resourceStatsHeight()["item"] * (i + 1); // remove active when exceeds stat height in pixels i.e. height of item * (2 + 1) i.e. 450
			statEnd = statEnd.toString(); // needs to be string
		}

		return {
			start: statStart,
			end: statEnd,
		};
	}

	/* loop through stats */
	resourceStats.forEach((stat, i) => {
		/* 
					create gsap timeline that is triggered by stats section
					toggle active class 
					when entering hide other stats
				*/
		gsap.timeline({
			scrollTrigger: {
				trigger: ".statistics",
				start: () => resourceStatPositions(i)["start"],
				end: () => resourceStatPositions(i)["end"],
				scrub: 1,
				invalidateOnRefresh: true,
				// markers: true,
				onToggle: () => {
					$(stat).toggleClass("is-active");
					$(resourceTitles[i]).toggleClass("is-active");
					$(resourceImgs[i]).toggleClass("is-active");
				},
				onEnter: () => {
					$(".statistics__stat.is-active")
						.prevAll()
						.addClass("is-hidden");
				},
				onEnterBack: () => {
					$(stat).removeClass("is-hidden");
				},
			},
		});
	});

	/* timeline to pin section in place */
	var resourceTl = gsap.timeline({
		scrollTrigger: {
			trigger: ".statistics",
			pin: true,
			start: "top top",
			end: () => "+=" + resourceStatsHeight()["total"],
			scrub: 1,
			invalidateOnRefresh: true,
			// markers: true,
		},
	});

	/* scroll stats when statistics section in view */
	resourceTl.to(".statistics__stats", {
		y: -resourceStatsHeight()["total"],
		ease: "none",
	});
});
